import { EMPTY_OBJECT } from 'commons-ui';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT } = params;
	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: '/dashboard/scheduledDowntime/edit',
					state: {
						rowData
					}
				});
			};
		case 'add':
			return () => {
				history.push({
					pathname: '/dashboard/scheduledDowntime/create'
				});
			};
		case 'back':
			return () => {
				history.push({
					pathname: '/dashboard/scheduledDowntime/list'
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
